import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ReferenceLine, Legend } from "recharts";

export default function ProjectionChart({ progress, period }) {
  if (!progress) return null;
  const hasPace = progress.pace_needed != null && progress.metric_type !== "lower" && progress.metric_type !== "rate";
  if (!hasPace) {
    const pct = Math.min(progress.pct, 100);
    return (
      <div data-testid="projection-simple" className="space-y-3">
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">Atual</span>
          <span className="font-semibold text-foreground">{progress.current}</span>
        </div>
        <div className="h-3 w-full rounded-full bg-white/8 overflow-hidden">
          <div className="h-full rounded-full bg-gradient-to-r from-[#FFD24D] to-[#FFAA00]" style={{ width: `${pct}%`, transition: "width .8s ease" }} />
        </div>
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">Meta</span>
          <span className="font-semibold text-accent">{progress.target}</span>
        </div>
        <p className="text-xs text-muted-foreground">Este indicador não depende de ritmo ao longo do tempo — compare o valor atual com a meta.</p>
      </div>
    );
  }
  const total = period?.days_total || 30;
  const elapsed = period?.days_elapsed || 1;
  const paceCur = progress.pace_current || 0;
  const paceNeed = progress.pace_needed || 0;
  const steps = 10;
  const data = [];
  for (let i = 0; i <= steps; i++) {
    const d = Math.round((total / steps) * i);
    data.push({
      dia: d,
      necessario: +(paceNeed * d).toFixed(1),
      atual: d <= elapsed ? +(paceCur * d).toFixed(1) : null,
      projecao: +(paceCur * d).toFixed(1),
    });
  }
  return (
    <div>
      <ResponsiveContainer width="100%" height={200}>
        <LineChart data={data} margin={{ top: 8, right: 8, left: -18, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.06)" />
          <XAxis dataKey="dia" tick={{ fill: "#8b8b93", fontSize: 11 }} tickLine={false} axisLine={false} unit="d" />
          <YAxis tick={{ fill: "#8b8b93", fontSize: 11 }} tickLine={false} axisLine={false} width={40} />
          <Tooltip contentStyle={{ background: "#121217", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 10, fontSize: 12 }}
            labelFormatter={(d) => `Dia ${d}`} />
          <Legend wrapperStyle={{ fontSize: 11 }} />
          <ReferenceLine y={progress.target} stroke="#FFAA00" strokeDasharray="4 4" label={{ value: "Meta", fill: "#FFAA00", fontSize: 11, position: "insideTopRight" }} />
          <Line type="monotone" dataKey="necessario" name="Ritmo necessário" stroke="#60a5fa" strokeWidth={2} dot={false} />
          <Line type="monotone" dataKey="projecao" name="Projeção (ritmo atual)" stroke="#FF4D00" strokeWidth={2} strokeDasharray="5 4" dot={false} />
          <Line type="monotone" dataKey="atual" name="Realizado" stroke="#FFD24D" strokeWidth={3} dot={false} />
        </LineChart>
      </ResponsiveContainer>
      <p className="sr-only">Projeção: mantendo o ritmo atual você termina com {progress.projection}. A meta é {progress.target}.</p>
    </div>
  );
}
